<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/RechargeList' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>资金明细</el-breadcrumb-item>
          <el-breadcrumb-item>出入金统计</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col
            :span="6"
            class="display-row"
          >
            <div class="query-title">创建开始日:</div>
            <div class="flex1">
              <el-date-picker
                v-model="queryInfo.startDate"
                type="month"
                size="small"
                value-format='yyyy-MM'
                placeholder="选择日期"
                :clearable="false"
                :editable="false"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col
            :span="6"
            class="display-row"
          >
            <div class="query-title">创建结束日:</div>
            <div class="flex1">
              <el-date-picker
                v-model="queryInfo.endDate"
                type="month"
                size="small"
                value-format='yyyy-MM'
                placeholder="选择日期"
                :clearable="false"
                :editable="false"
              >
              </el-date-picker>
            </div>
          </el-col>
          <el-col
            :span="12"
            class="display-row"
          >
            <div style="text-align:right;width:100%;padding-right:10px;floate:right">
              <el-button
                class="search-btn btn-gray"
                @click="queryInfoClear"
              >重置</el-button>
              <el-button
                class="search-btn btn-blue"
                @click="searchList"
              >搜索</el-button>
              <el-button
                class="search-btn btn-green"
                @click="exportAction"
              >导出</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <div
        slot="table"
        class="full-height display-col"
      >
        <div class="tips">
          <span class="tip-item">充值总额：{{addThousandSeparator(form.recharge)}}元</span>
          <span class="tip-item">退金总额：{{addThousandSeparator(form.withdrawal)}}元</span>
          <span class="tip-item">净充值总额：{{addThousandSeparator(form.netCapital)}}元</span>
          <span class="tip-item">当前用户总余额：{{addThousandSeparator(form.totalBalance)}}元</span>
        </div>
        <el-table
          :data="recordList"
          :header-cell-style="tableStyle.headerStyle"
          :cell-style="tableStyle.cellStyle"
          border
          height="550"
        >
          <el-table-column
            type="index"
            align="center"
            label="序号"
            width="40"
          ></el-table-column>
          <el-table-column
            prop="date"
            align="center"
            label="月份"
          >
          </el-table-column>
          <el-table-column
            prop="recharge"
            align="center"
            label="客户充值"
          >
            <template v-slot="scope">
              {{ addThousandSeparator(scope.row.recharge) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="withdrawal"
            align="center"
            label="客户退金(提现)"
          >
            <template v-slot="scope">
              {{ addThousandSeparator(scope.row.withdrawal) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="netCapital"
            align="center"
            label="资金净流入"
          >
            <template v-slot="scope">
              {{ addThousandSeparator(scope.row.netCapital) }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'

export default {
  components: { tableCon },
  name:'access',
  data () {
    return {
      queryInfo: {
        startDate: '',
        endDate: '',
        pageSize: 10,
        pageNum: 1
      },
      recordList: [],
      total: 0,
      form: {},
    }
  },
  methods: {
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    getTime () {
      var date = new Date();
      var year = date.getFullYear();
      var firstMonth = year + '-' + '01';
      this.queryInfo.startDate = firstMonth
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      var currentdate = year + '-' + month;
      this.queryInfo.endDate = currentdate
      this.getrecordList();
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
    async exportAction () {
      this.$http({
        url: '/financial/exportBalanceChange',
        method: 'get',
        params: this.queryInfo,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '出入金统计列表.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        console.log(err);
      })
    },
    searchList () {    //查询
      this.queryInfo.pageNum = 1;
      this.getrecordList();
      this.getTool();
    },
    async getrecordList () {
      const { data: res } = await this.$http.get('financial/queryBalanceChange', { params: this.queryInfo });
      this.recordList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear () {    //清空
      this.queryInfo.pageSize = 10
      this.queryInfo.pageNum = 1
      var date = new Date();
      var year = date.getFullYear();
      var firstMonth = year + '-' + '01' + '-' + '01';
      this.queryInfo.startDate = firstMonth
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      var currentdate = year + '-' + month + '-' + day;
      this.queryInfo.endDate = currentdate
    },
    async getTool () {
      const { data: res } = await this.$http.get('financial/queryBalanceChangeHeader', { params: this.queryInfo });
      this.form = res.data
    }
  },
  created () {
    this.getTime()
    this.getTool()
  }
};
</script>

<style lang="less" scoped>
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}
.tips {
  margin: 15px 0;
  text-align: right;
}
.tip-item{
  margin-left: 30px;
}
.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
</style>
